module.exports = __webpack_public_path__ + "img/trash.d479fa9b.svg";